import React from 'react';

const People = () => {
  return (
    <main className="min-h-screen pt-20">
      <section className="bg-cream py-20 md:py-32">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-center text-espresso mb-8">
            Our People
          </h1>
          <div className="h-1 w-24 bg-burnt-amber mx-auto mb-12"></div>
          <p className="font-nunito text-center text-espresso/80 text-lg max-w-3xl mx-auto">
          At Brunch Club Hospitality, our people are at the heart of everything we create. From our chefs to our service teams, we bring together individuals who are passionate about food and meaningful experiences. We believe in nurturing talent, encouraging fresh ideas, and building a culture where every team member feels empowered to contribute and grow.
          </p>
          
          <div className="mt-20 text-center">
            <p className="font-nunito text-espresso/60">Content coming soon...</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default People;

